import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Shield, ArrowLeft, Home } from "lucide-react";

export default function AdminAccessDenied() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoAdminLogin = () => {
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="rounded-2xl shadow-xl border-red-200">
          <CardHeader className="text-center">
            <div className="mx-auto w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-4">
              <Shield className="w-6 h-6 text-red-600" />
            </div>
            <CardTitle className="text-2xl font-bold text-gray-900">
              Acesso Negado
            </CardTitle>
            <CardDescription className="text-gray-600">
              Este painel é restrito para administradores do sistema.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="bg-red-50 border border-red-200 rounded-xl p-4">
              <p className="text-sm text-red-800">
                <strong>Motivo:</strong> Sua conta não possui privilégios de administrador.
              </p>
              <p className="text-sm text-red-700 mt-2">
                Se você acredita que isso é um erro, entre em contato com o administrador do sistema.
              </p>
            </div>
            
            <div className="flex flex-col gap-2">
              <Button
                variant="outline"
                onClick={handleGoAdminLogin}
                className="w-full h-11"
              >
                Ir para Login Admin
              </Button>

              <Button
                onClick={handleGoHome}
                className="w-full h-11 bg-violet-600 hover:bg-violet-700"
              >
                <Home className="w-4 h-4 mr-2" />
                Ir para Página Inicial
              </Button>
              
              <Button 
                variant="outline"
                onClick={handleGoBack}
                className="w-full h-11"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Voltar
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
